import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Popconfirm } from "antd";
import { toast } from "react-toastify";
import Spinner from "views/lib/components/Spinner";
import { sendNotification } from "actions/users/actions";
import { getNoPagination } from "actions/notificationTemplates/actions";
import { languageGetSearch } from "actions/language/requests";

class ModalNotification extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      loading: false,
      messages: {},
    };
  }

  componentDidMount() {
    if (!this.props.templates.length) {
      this.props.getNoPagination();
    }

    this.props.languageGetSearch(0, 10000, undefined);
  }

  onSubmit = () => {
    this.props.sendNotification({
      content: this.state.messages,
      filters: this.props.filters,
    }, () => this.props.onSubmit());
  };

  handleChangeTemplate = (ev) => {
    const id = ev.target.value;
    const template = this.props.templates.find(item => item.id === id);
    console.log("templatetemplate", template);
    if (template) {
      this.setState({
        messages: template
      });
    } else {
      toast(`Template with id(${id}) not found`, {
        type: toast.TYPE.ERROR
      });
    }
  };

  render() {
    const {
      templates,
      languages,
    } = this.props;

    const {
      loading,
      messages,
    } = this.state;

    console.log("languages", languages, templates, this.state);

    return (
      <div className="position-relative">
        {!loading || <Spinner/>}

        <div className="form-inline">
          <div className="form-group mb-3">
            <label className="mr-3">Notification Templates</label>
            <select
              className="form-control"
              onChange={this.handleChangeTemplate}
              defaultValue={false}
            >
              <option disabled={true} value={false}>Select...</option>
              {templates.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          {languages.map(language => (
            <div key={language.id} className="col-12 col-md-4">
              <div className="card">
                <div className="p-3 card-body">
                  <h5 className="card-title">{language.name}</h5>
                  <div className="form-group">
                    <input
                      placeholder="Title"
                      className="form-control"
                      type="text"
                      value={messages[language.id] ? messages[language.id].title : ""}
                      onChange={ev => {
                        this.setState({
                          messages: {
                            ...this.state.messages,
                            [language.id]: {
                              content: this.state.messages[language.id] ? this.state.messages[language.id].content : "",
                              title: ev.target.value
                            }
                          }
                        });
                      }}
                    />
                  </div>
                  <div className="form-group m-0">
                                    <textarea
                                      placeholder="Message"
                                      rows={6}
                                      className="form-control"
                                      value={messages[language.id] ? messages[language.id].content : ""}
                                      onChange={ev => {
                                        this.setState({
                                          messages: {
                                            ...this.state.messages,
                                            [language.id]: {
                                              title: this.state.messages[language.id] ? this.state.messages[language.id].title : "",
                                              content: ev.target.value
                                            }
                                          }
                                        });
                                      }}
                                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-danger"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <Popconfirm
            title="Are you sure?"
            onConfirm={this.onSubmit}
            placement="top"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-success">
              Send
            </button>
          </Popconfirm>
        </div>
      </div>
    );
  }
}

ModalNotification.defaultProps = {
  filters: []
};

ModalNotification.propTypes = {
  filters: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  templates: state.notificationTemplates.list,
  languages: state.language.list.content,
});

const mapStateToDispatch = dispatch => ({
  sendNotification: bindActionCreators(sendNotification, dispatch),
  getNoPagination: bindActionCreators(getNoPagination, dispatch),
  languageGetSearch: bindActionCreators(languageGetSearch, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ModalNotification);



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-notification.js